import { Component, h } from '@stencil/core';


@Component({
  tag: 'sg-pagenot',
  shadow: false
})
export class Pagenot {

  render() {
    
      return (
        <div class="Grid-cell u-lg-size4of4 u-textCenter u-contai">
        <div class="u-borderBottomSm u-borderBlack u-padBottom3 u-spaceBottom3">
          <h1 class="u-textSize6">Oops!</h1>
        </div>
        <div class="u-bgOrange u-pullTop4 u-size1of8 u-flexExpand u-padTop03"></div>
        <div class="Grid Grid--withGap u-spaceTop1 u-spaceBottom6">
          <div class="Grid-cell u-spaceItems6 u-textCenter">
            <p class="u-textSize3">Page not found</p>
            
          </div>
        </div>
      </div>
      );

  }
}
